import { get } from '../utils/api';

class CommercialRetailTypesService {
  getAll(organizationId: string, options?: Object) {
    return get(`/${organizationId}/commercial-retail-types`, options);
  }
}

export default CommercialRetailTypesService;
